/*
 * @Descripttion: 
 * @version: 
 * @Author: 陈宇鹏
 * @Date: 2021-06-28 18:07:15
 * @LastEditors: 陈宇鹏
 * @LastEditTime: 2021-07-22 16:21:08
 */
import Cookies from "js-cookie";
import * as sysTool from "@/utils/systemTool";
import { encryptAes, decryptAes } from "@/utils/encryption.js";
export function setUrlList() {
    let arr = [
        // 'talentRecom',
        'talentFind',
        'talentDetail',
        'tweetList',
        'tweetRecommend',
        'succPanel',
        'candidateNews',
        'communicateRecord',
        'askQuestions',
        'recommendReport',
        // 'privacyPhone',
        'talentPool',
        'AuthorizationInformation',
        'IsEnterprise',
        'SettleIn',
        'Certification',
        'companyEntry',
        'AplayToJoin',
        'ContractLink',
        'EnterpriseAuth','RealName']
    return arr
}
export function setUrl() {

    //分享特殊处理
    let sharaUrl = ''
    if (window.location.href.indexOf('code=') != -1) {
        let index = window.location.href.indexOf('code=')
        sharaUrl = window.location.href.substr(0, index - 1)
    } else {
        sharaUrl = window.location.href
    }

    // 分享带uerId
    let setUserId = () => {
        let loginInfo = Cookies.get("loginInfo")
            ? JSON.parse(Cookies.get("loginInfo"))
            : "";
        if (loginInfo) {
            sharaUrl = sharaUrl + '&num=' + loginInfo.member_info.id
        }
    }
    //日报分享特殊处理
    if (window.location.href.indexOf('actingOperationDaily') != -1) {
        setUserId()
    }
    //详情页转发替换
    if (window.location.href.indexOf('positionDetail') != -1) {
        let jobId = sysTool.GetRequest().job_id


        let index = window.location.href.indexOf('jobType=')
        let jobType = window.location.href.substr(index + 8, index + 9)
        // 分享加密处理
        if (jobId.indexOf('_') > -1) {
            if (jobType >= 7) {
                setUserId()
            }
        } else {
            let job_id = encryptAes(jobId);
            let codes = sysTool.GetRequest().codes;
            if (process.env.NODE_ENV === "development") {
                sharaUrl = `http://h5test.hewa.cn/positionDetail?job_id=${job_id}&codes=${codes}`;
            } else {
                sharaUrl = `http://h5.hewa.cn/positionDetail?job_id=${job_id}&codes=${codes}`;
            }
        }

    }
    // 推荐列表
    if (window.location.href.indexOf('tweetList') != -1 || window.location.href.indexOf('tweetRecommend') != -1) {
        let index = window.location.href.indexOf('?job_id')
        sharaUrl = window.location.href.substr(0, index)
    }
    // 特殊分享返回列表
    let shareList = setUrlList()
    shareList.forEach(item => {
        if (window.location.href.indexOf(item) != -1) {
            setUserId()
        }
    })
    return sharaUrl
}